// ============================================
// GANTT i18n HELPERS
// ============================================
//
// t17: pure helpers that resolve display labels for the Gantt view's
// config-driven UI (timeScale, groupBy, status). Mirrors
// calendar-i18n.ts but stays Gantt-only.

import type { TaskStatus } from '@/lib/schemas';

export type TranslateFn = (key: any) => string;

// Translate the active timeScale into a user-facing label.
export function getTimeScaleLabel(
    timeScale: string,
    t: TranslateFn
): string {
    return t(`gantt.timeScale.${timeScale}`);
}

// Translate the active groupBy setting into a label.
export function getGroupByLabel(
    groupBy: string,
    t: TranslateFn
): string {
    return t(`gantt.groupBy.${groupBy}`);
}

// Translate a task status into its Gantt-side label. Falls back to the
// raw status value when no translation is found so unrecognised statuses
// never silently disappear from the row header.
export function getStatusLabel(
    status: TaskStatus,
    t: TranslateFn
): string {
    const key = `gantt.status.${status}`;
    const translated = t(key as any);
    return translated === key ? status : translated;
}
